import React from 'react';
import Select from '../select';
import { ConfigContext } from '../config-provider';
const MultiSelectInput = props => {
    const { prefixCls: customizePrefixCls, defaultValue, placeholder = '请输入或点击进行选择', options, style } = props;
    const handleOnChange = (e) => {
        if (props.onChange) {
            props.onChange(e);
        }
    };
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('input-select', customizePrefixCls);
    return (<Select mode="tags" style={style} allowClear showArrow={false} showSearch placeholder={placeholder} defaultValue={defaultValue} onChange={handleOnChange} className={`${prefixCls}-tags`} dropdownClassName={`${prefixCls}-tags`}>
            {options}
        </Select>);
};
export default MultiSelectInput;
